var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66797 4.9987C1.66797 4.07822 2.41416 3.33203 3.33464 3.33203H16.668C17.5884 3.33203 18.3346 4.07822 18.3346 4.9987V14.9987C18.3346 15.9192 17.5884 16.6654 16.668 16.6654H3.33464C2.41416 16.6654 1.66797 15.9192 1.66797 14.9987V4.9987ZM16.668 4.9987L3.33464 4.9987V14.9987H16.668V4.9987Z",
    fill: "#161B2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66797 7.99878C1.66797 7.53854 2.04106 7.16545 2.5013 7.16545H17.5013C17.9615 7.16545 18.3346 7.53854 18.3346 7.99878C18.3346 8.45902 17.9615 8.83211 17.5013 8.83211H2.5013C2.04106 8.83211 1.66797 8.45902 1.66797 7.99878Z",
    fill: "#161B2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0013 11.6654C5.0013 11.2051 5.3744 10.832 5.83464 10.832H7.5013C7.96154 10.832 8.33464 11.2051 8.33464 11.6654C8.33464 12.1256 7.96154 12.4987 7.5013 12.4987H5.83464C5.3744 12.4987 5.0013 12.1256 5.0013 11.6654Z",
    fill: "#161B2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineIcon);
export default __webpack_public_path__ + "static/media/onlineIcon.9e960b3d3d5861b8427743b77f4a3554.svg";
export { ForwardRef as ReactComponent };